import { useCallback } from "react";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import { usePaymentForm } from "../PaymentFormContext";

import { useSetAuthToLoggedIn } from "./LoginForm/VerifyCode/useSetAuthToLoggedIn";

const useResetClientAuthState = () => {
  const { dispatch: formDispatch } = usePaymentForm();
  const {
    state: { amount },
    dispatch: pageDispatch,
  } = usePaymentPage();

  return useCallback(() => {
    pageDispatch({
      type: "logoutUser",
    });
    formDispatch({
      type: "setFormStages",
      payload: {
        auth: amount ? "requestCode" : "untouched",
        paymentInfo: "untouched",
      },
    });
    pageDispatch({ type: "setEditingRecurringPayment", payload: false });

    if (window.data.paymentPageData.campaign) {
      window.data.paymentPageData.campaign.pledge = {}; // clears user pledge data
    }
    window.data.paymentPageData.user = {}; // clears user data
  }, [amount, formDispatch, pageDispatch]);
};

const useSetClientAuthState = () => {
  const { dispatch } = usePaymentPage();
  const setAuthToLoggedIn = useSetAuthToLoggedIn();

  return useCallback(
    ({ paymentMethods, givePageUserInfo, campaign }) => {
      dispatch({
        type: "setPaymentMethods",
        payload: paymentMethods,
      });
      dispatch({
        type: "setUser",
        payload: givePageUserInfo,
      });
      setAuthToLoggedIn({ hasPaymentMethod: paymentMethods?.length > 0 });
      window.data.paymentPageData.user = givePageUserInfo;
      window.data.paymentPageData.campaign = campaign;
    },
    [dispatch, setAuthToLoggedIn]
  );
};

const useSyncClientAuthState = () => {
  const resetClientAuthState = useResetClientAuthState();
  const setClientAuthState = useSetClientAuthState();

  return useCallback(
    (newAuthState) => {
      if (!newAuthState) resetClientAuthState();
      else setClientAuthState(newAuthState);
    },
    [resetClientAuthState, setClientAuthState]
  );
};

export {
  useSetClientAuthState,
  useResetClientAuthState,
  useSyncClientAuthState,
};
